import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { RND_ONBOARDING_STEP } from "constants/financialClosing";
import {
  useGetRnDBifurcationQuery,
  useUpdateRnDOnboardingStepMutation,
} from "store/apis/financialClosing";
import { ProjectedTaxImpact } from "./ProjectedTaxImpact";
import {
  RnDBifurcationSection,
  SaveIndicator,
  useRnDUpdateField,
} from "./RnDBifurcationSection";

type RnDReviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onViewGuide: () => void;
  entityId: string;
  financialClosingId: string;
  isFormEditable: boolean;
  closingDate?: string | null;
};

export const RnDReviewModal = ({
  isOpen,
  onClose,
  onViewGuide,
  entityId,
  financialClosingId,
  isFormEditable,
  closingDate,
}: RnDReviewModalProps) => {
  const { data: rndData } = useGetRnDBifurcationQuery(
    { entityId, financialClosingId },
    { skip: !entityId || !financialClosingId || !isOpen }
  );
  const { updateField, saveState } = useRnDUpdateField(
    entityId,
    financialClosingId
  );
  const [updateOnboardingStep] = useUpdateRnDOnboardingStepMutation();

  const handleFinishReview = () => {
    void updateOnboardingStep({
      entityId,
      financialClosingId,
      payload: {
        step: RND_ONBOARDING_STEP.COMPLETED,
        mark_completed: true,
      },
    });
    onClose();
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={onClose}>
      <Modal.Content size="xxxl" className="t-rounded-md t-h-[90vh]">
        <Modal.Header className="!t-px-8">
          <div className="t-flex t-items-center t-gap-3">
            <Modal.Title>R&D Expense Bifurcation</Modal.Title>
            <SaveIndicator
              isSaving={saveState.isSaving}
              isSaved={saveState.isSaved}
            />
          </div>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body asChild>
          <div className="t-m-0 t-w-full t-h-[650px] t-min-h-0 t-px-8 t-pt-4 t-overflow-y-auto t-flex t-gap-4">
            <div className="t-flex-1 t-min-w-0">
              <RnDBifurcationSection
                entityId={entityId}
                financialClosingId={financialClosingId}
                isFormEditable={isFormEditable}
                showOuterAccordion={false}
                updateField={updateField}
              />
            </div>
            <div className="t-w-80 t-shrink-0 t-overflow-y-auto t-h-full">
              <ProjectedTaxImpact
                data={rndData?.projected_tax_impact}
                entityId={entityId}
                closingDate={closingDate}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="t-flex t-items-center t-justify-between t-shrink-0">
          <Button type="button" customType="link_neutral" onClick={onViewGuide}>
            View guide
          </Button>
          <Button
            type="button"
            customType="primary"
            onClick={handleFinishReview}
          >
            Finish review
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
};
